import { Box, Button, Typography } from "@mui/material";
import { useState } from "react";

import SimpleModal from "@/components/SimpleModal.tsx";
import { forceReload } from "@/models/BootstrapUtils.ts";

/**
 * The visible end of a cold bootstrap that failed: the store holds whatever pages landed and nothing more, so the
 * only way forward is a fresh boot. The one action wipes the local snapshot and reloads.
 */
export default function BootstrapFailedModal({ open }: { open: boolean }) {
  const [busy, setBusy] = useState(false);

  const reload = () => {
    setBusy(true);
    // `forceReload` reloads the page itself once the wipe settles, whether or not the wipe succeeded.
    forceReload().catch(() => {});
  };

  return (
    <SimpleModal disableClose={true} open={open} title="This workspace could not be loaded">
      <Box sx={{ textAlign: "center" }}>
        <Typography sx={{ mb: 3 }}>
          Loading stopped before the workspace was whole. Reload to start over; your browser's copy of the workspace is
          cleared first.
        </Typography>
        <Button disabled={busy} onClick={reload} variant="contained" className="basic-button">
          Clear cache and reload
        </Button>
      </Box>
    </SimpleModal>
  );
}
